export interface IQuery { }

export class CorporatePnlTemplateByIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Pnls.Queries.CorporatePnlTemplateByIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	PnlId: string

	constructor (workspaceId: number, strategyId: string, pnlId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.PnlId = pnlId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Pnls.Queries.CorporatePnlTemplateByIdQueryV1, TCh.Domain.Quest'
	}

}

export class CorporatePnlTemplatesByStrategyIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Pnls.Queries.CorporatePnlTemplatesByStrategyIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Pnls.Queries.CorporatePnlTemplatesByStrategyIdQueryV1, TCh.Domain.Quest'
	}

}

export class DefaultPnlTemplateByIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Pnls.Queries.DefaultPnlTemplateByIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	TemplateId: string

	constructor (workspaceId: number, strategyId: string, templateId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.TemplateId = templateId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Pnls.Queries.DefaultPnlTemplateByIdQueryV1, TCh.Domain.Quest'
	}

}

export class PnlsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Pnls.Queries.PnlsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Pnls.Queries.PnlsPageQueryV1, TCh.Domain.Quest'
	}

}

